/* PoweRage landing page: show one bike's products at a time.
   34 products stacked is 3000px+ of scroll on a phone and nobody gets past
   their own model. Picking a bike reveals only that group.
   Deep link: /pages/powerage?bike=<handle> preselects a bike so an ad can
   land straight on the right model. Falls back to showing the picker. */
(function () {
  function init() {
    var root = document.querySelector('[data-pa]');
    if (!root) return;

    var buttons = [].slice.call(root.querySelectorAll('[data-pa-bike]'));
    var groups = [].slice.call(root.querySelectorAll('[data-pa-model]'));
    var bar = root.querySelector('[data-pa-bar]');
    var barName = root.querySelector('[data-pa-barname]');
    var reset = root.querySelector('[data-pa-reset]');
    var picker = root.querySelector('[data-pa-picker]');
    if (!buttons.length || !groups.length) return;

    function show(key, scroll) {
      var found = false;
      groups.forEach(function (g) {
        var on = g.getAttribute('data-pa-model') === key;
        g.classList.toggle('is-on', on);
        if (on) found = true;
      });
      buttons.forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-pa-bike') === key);
        b.setAttribute('aria-pressed', b.getAttribute('data-pa-bike') === key ? 'true' : 'false');
      });
      if (!found) return clear();
      if (bar && barName) {
        var active = buttons.filter(function (b) { return b.getAttribute('data-pa-bike') === key; })[0];
        barName.textContent = active ? (active.getAttribute('data-pa-label') || '') : '';
        bar.classList.add('is-on');
      }
      if (scroll) {
        var target = root.querySelector('[data-pa-model="' + key + '"]');
        if (target) {
          var y = target.getBoundingClientRect().top + (window.pageYOffset || 0) - 56;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }
    }

    function clear() {
      groups.forEach(function (g) { g.classList.remove('is-on'); });
      buttons.forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); });
      if (bar) bar.classList.remove('is-on');
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.getAttribute('data-pa-bike');
        if (b.classList.contains('is-on')) { clear(); return; }
        show(key, true);
      });
    });

    if (reset) {
      reset.addEventListener('click', function () {
        clear();
        if (picker) {
          var y = picker.getBoundingClientRect().top + (window.pageYOffset || 0) - 12;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      });
    }

    // Preselect from the URL so a campaign can deep link to one model.
    var q = null;
    try { q = new URLSearchParams(window.location.search).get('bike'); } catch (e) {}
    if (q) {
      var match = buttons.filter(function (b) { return b.getAttribute('data-pa-bike') === q; })[0];
      if (match) show(q, false);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
